module.exports = [
  "Аеродром",
  "Арачиново",
  "Берово",
  "Битола",
  "Богданци",
  "Боговиње",
  "Босилово",
  "Брвеница",
  "Бутел",
  "Валандово",
  "Василево",
  "Вевчани",
  "Велес",
  "Виница",
  "Вранештица",
  "Врапчиште",
  "Гази Баба",
  "Гевгелија",
  "Гостивар",
  "Градско",
  "Дебар",
  "Дебарца",
  "Делчево",
  "Демир Капија",
  "Демир Хисар",
  "Дојран",
  "Долнени",
  "Другово",
  "Ѓорче Петров",
  "Желино",
  "Зајас",
  "Зелениково",
  "Зрновци",
  "Илинден",
  "Јегуновце",
  "Кавадарци",
  "Карбинци",
  "Карпош",
  "Кисела Вода",
  "Кичево",
  "Конче",
  "Кочани",
  "Кратово",
  "Крива Паланка",
  "Кривогаштани",
  "Крушево",
  "Куманово",
  "Липково",
  "Лозово",
  "Маврово и Ростуше",
  "Македонска Каменица",
  "Македонски Брод",
  "Могила",
  "Неготино",
  "Новаци",
  "Ново Село",
  "Осломеј",
  "Охрид",
  "Петровец",
  "Пехчево",
  "Пласница",
  "Прилеп",
  "Пробиштип",
  "Радовиш",
  "Ранковце",
  "Ресен",
  "Росоман",
  "Сарај",
  "Свети Николе",
  "Скопје",
  "Сопиште",
  "Струга",
  "Старо Нагоричане",
  "Струмица",
  "Студеничани",
  "Теарце",
  "Тетово",
  "Центар",
  "Центар Жупа",
  "Чаир",
  "Чашка",
  "Чешиново-Облешево",
  "Чучер-Сандево",
  "Штип",
  "Шуто Оризари"
];
